import { NoBreadcrumbData, PAGES } from '../types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Community = (data: NoBreadcrumbData) => {
  return [
    {
      page: PAGES.COMMUNITY,
      link: `/community`,
      label: 'Community',
    },
  ];
};
